import { changeStandalonePath } from './openChangeInNewBrowserTab';

export const DASHBOARD_CHANGE_HISTORY_KEY = 'yodaDashboardChange';

type ProjectRef = string | { slug?: string; _id?: string } | null | undefined;

type ChangeLike = {
    _id?: string;
    project?: ProjectRef;
} | null | undefined;

export type DashboardChangeHistoryState = {
    yodaDashboardChange?: boolean;
    returnPath?: string;
};

/** True when this history entry was pushed/replaced by the dashboard modal sync. */
export function isDashboardChangeHistoryState(state: unknown): state is DashboardChangeHistoryState {
    return Boolean(
        state
        && typeof state === 'object'
        && (state as DashboardChangeHistoryState).yodaDashboardChange === true
    );
}

/** Canonical change path shape used for shareable dashboard URLs. */
export function isCanonicalChangePath(pathname: string): boolean {
    return /^\/projects\/[^/]+\/change\/[^/]+\/?$/.test(pathname);
}

function currentLocationPath(): string {
    const path = `${window.location.pathname || '/'}${window.location.search || ''}`;
    return path || '/';
}

/**
 * Update the address bar to the canonical change URL without React Router navigation,
 * so the dashboard (and its modal) stay mounted.
 */
export function pushDashboardChangeUrl(
    change?: ChangeLike,
    projectFallback?: ProjectRef,
): boolean {
    if (typeof window === 'undefined')
        return false;
    const path = changeStandalonePath(change, projectFallback);
    if (!path)
        return false;

    const prev = window.history.state as DashboardChangeHistoryState | null;
    const returnPath = isDashboardChangeHistoryState(prev) && prev.returnPath
        ? prev.returnPath
        : currentLocationPath();
    const state: DashboardChangeHistoryState = {
        yodaDashboardChange: true,
        returnPath,
    };

    if (isDashboardChangeHistoryState(prev))
        window.history.replaceState(state, '', path);
    else
        window.history.pushState(state, '', path);

    return true;
}

/**
 * Restore the dashboard URL in the address bar without React Router navigation.
 */
export function restoreDashboardUrl(): void {
    if (typeof window === 'undefined')
        return;

    const state = window.history.state as DashboardChangeHistoryState | null;
    const returnPath = (
        isDashboardChangeHistoryState(state) && state.returnPath
            ? state.returnPath
            : '/'
    ) || '/';

    if (currentLocationPath() === returnPath && !isDashboardChangeHistoryState(state))
        return;

    window.history.replaceState(null, '', returnPath);
}
